// DataChannel "h264" do ByCall — port de video-channel.ts.
// Abre o canal SEMPRE (mesmo em chamada só de áudio) p/ upgrade mid-call sem
// renegociar SDP. Se o navegador não tiver WebCodecs (ou algo falhar), cai no
// canal no-op — NUNCA derruba o áudio.
import {
  H264_CHANNEL_LABEL,
  VideoReceiver,
  VideoSender,
  videoSupported,
} from './videoCodec';

const noVideoChannel = {
  remoteVideoStream: null,
  startSender: () => {},
  stopSender: () => {},
  close: () => {},
};

const buildVideoChannel = pc => {
  const receiver = new VideoReceiver();
  const videoDc = pc.createDataChannel(H264_CHANNEL_LABEL, {
    ordered: false,
    maxRetransmits: 0,
  });
  videoDc.binaryType = 'arraybuffer';
  videoDc.onmessage = e => receiver.decode(e.data);

  let sender = null;
  let pending = null;
  let open = false;

  const startNow = track => {
    if (sender) sender.close();
    sender = new VideoSender(track, au => {
      if (videoDc.readyState === 'open') videoDc.send(au);
    });
  };

  videoDc.onopen = () => {
    open = true;
    if (pending) {
      startNow(pending);
      pending = null;
    }
  };

  return {
    remoteVideoStream: receiver.stream,
    startSender: track => {
      if (open) startNow(track);
      else pending = track; // envia assim que o canal abrir
    },
    stopSender: () => {
      try {
        if (sender) sender.close();
      } catch (e) {
        /* noop */
      }
      sender = null;
      pending = null;
    },
    close: () => {
      try {
        if (sender) sender.close();
      } catch (e) {
        /* noop */
      }
      try {
        receiver.close();
      } catch (e) {
        /* noop */
      }
    },
  };
};

export const setupVideoChannel = pc => {
  if (!videoSupported()) return noVideoChannel;
  try {
    return buildVideoChannel(pc);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('video channel setup failed; audio-only call', e);
    return noVideoChannel;
  }
};
